import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import { gettext } from '@eb/i18n';

import {
    withFollowList,
    FollowList,
    addFollow,
} from '@eb/follow-organizer-ebui';

import './organizerFollowBucket.scss';
import { useQueryClient } from 'react-query';
import { EVENT_TYPE } from '../../../../constants';

const listStyle = 'grid';
const size = 'mini';
const EnhancedFollowList = withFollowList(FollowList);

const useOrganizers = ({ placeId, isOnline }) => {
    const queryClient = useQueryClient();
    const { pages } = queryClient.getQueryData([
        'browse-buckets',
        placeId,
        isOnline,
    ]);
    const organizers = React.useMemo(() => {
        return pages
            .reduce((memo, page) => {
                const currentPageOrganizers = page.buckets.reduce(
                    (memo, bucket) => {
                        if (bucket.type === EVENT_TYPE) {
                            return [
                                ...memo,
                                ...bucket.content.map(
                                    (event) => event.organizerId,
                                ),
                            ];
                        }

                        return memo;
                    },
                    [],
                );

                return [...memo, ...currentPageOrganizers];
            }, [])
            .slice(0, 20);
    }, [pages]);

    return organizers;
};

export const OrganizerFollowBucket = (props) => {
    const { isListEmpty, setListEmpty } = React.useState(false);
    const {
        userId,
        gaCategory,
        gaActionSuffix,
        isAuthenticated,
        trackGAEvent,
        gaSettings,
        isGDPRCountry,
        placeId,
        isOnline,
    } = props;
    const organizers = useOrganizers({ placeId, isOnline });
    const hasNoOrganizers = !organizers || isEmpty(organizers);
    const shouldShowEmptyBucket = isListEmpty || hasNoOrganizers;

    if (shouldShowEmptyBucket) {
        return <div className="organizer-follow-bucket__follow-empty" />;
    }

    const EnhancedFollowListWithData = addFollow(EnhancedFollowList);

    return (
        <div
            className="
                    content-bucket
                    organizer-follow-bucket
                "
        >
            <div className="eds-l-pad-hor-3">
                <div
                    className="
                            bucket-header__title
                            eds-g-cell
                            eds-g-cell-9-12
                            "
                >
                    <h2
                        className="
                            eds-text-hs
                            eds-text-color--grey-700
                        "
                    >
                        {gettext('Featured Organizers')}
                    </h2>
                    <p className="eds-text-bm eds-text-color--grey-600">
                        {gettext(
                            'Follow the organizers from these events and get notified when they create new ones.',
                        )}
                    </p>
                </div>
            </div>
            <div className="organizer-follow-bucket__follow-container">
                <EnhancedFollowListWithData
                    isGDPRCountry={isGDPRCountry}
                    style={listStyle}
                    size={size}
                    onEmpty={() => setListEmpty(true)}
                    isClosable={true}
                    isHiddenWhenFollowed={true}
                    shouldHideDefaultDataPoint={true}
                    organizers={organizers}
                    userId={userId}
                    gaCategory={gaCategory}
                    gaActionSuffix={gaActionSuffix}
                    isAuthenticated={isAuthenticated}
                    trackGAEvent={trackGAEvent}
                    gaSettings={gaSettings}
                />
            </div>
        </div>
    );
};

export default OrganizerFollowBucket;
